import { privateApi } from '../ApiService/PrivateApi';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';
import { GoogleAnalyticsEventMapping } from './types';

const updateGoogleAnalyticsEventMapping = async (
    businessAccountId: string,
    payload: GoogleAnalyticsEventMapping,
): Promise<void> =>
    privateApi.put<void>(`business-accounts/${businessAccountId}/google-analytics-event-mapping`, payload);

export const GoogleAnalyticsGateway = {
    updateGoogleAnalyticsEventMapping,
};

const cancelableFetchGoogleAnalyticsEventMapping = async (
    businessAccountId: string,
): Promise<GoogleAnalyticsEventMapping> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<GoogleAnalyticsEventMapping>(
        `business-accounts/${businessAccountId}/google-analytics-event-mapping`,
    );

export const CancelableGoogleAnalyticsGateway = {
    cancelableFetchGoogleAnalyticsEventMapping,
};
